import { campaignMetrics, ChartDataResponse, Dimensions } from "@api/common";
import { AppState, currentReportCampaign, toPieData } from "@store";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";
import { ChartWithTable, ChartWithTableProps } from "./ChartWithTable";
import "./DynamicAdPlacementReports.css";
import { Pie } from "./PieChart";

export const DynamicAdPlacement = connect(
    (state: AppState): ChartWithTableProps => {
        const data: ChartDataResponse = FetchingState.getDataOrDefault(state.reports.chartData.environmentData, {
            metrics: [],
            dimensions: []
        });

        const campaign = currentReportCampaign(state);
        const metrics = campaignMetrics(campaign ? campaign.unit : "CPM");

        return {
            title: "Ad Placement",
            subtitle: "DISTRIBUTION OF ADS BETWEEN WEB AND IN APP",
            data,
            metrics,
            dimensions: Dimensions.Environment,
            children: metric => <Pie circleWidth={10} data={toPieData(data, metric, Dimensions.Environment)} />
        };
    }
)(ChartWithTable);
